import { makeAutoObservable } from 'mobx'
import { Calling } from 'entities/Call'
import type { IResponseEventConversationCalling } from 'entities/Call/api/types'

export class CallingContentStore {
  private _callingMap: Map<number, Calling> = new Map()

  constructor(private _getConversationId: () => number) {
    makeAutoObservable(this)
  }

  get callings(): Calling[] {
    return Array.from(this._callingMap.values())
  }

  get callingsCount() {
    return this.callings.length
  }

  handleConversationCallingEvent = (data: IResponseEventConversationCalling) => {
    if (data.conversation_id !== Number(this._getConversationId())) return

    if (!data.is_calling) {
      const existing = this._callingMap.get(data.id)
      if (existing) clearTimeout(existing.timerId)
      this._callingMap.delete(data.id)
      return
    }

    const timerId = setTimeout(() => {
      this._callingMap.delete(data.id)
    }, 10000)
    const newCalling = new Calling(data, timerId)
    const oldCalling = this._callingMap.get(newCalling.userId)
    if (oldCalling) {
      clearTimeout(oldCalling.timerId)
    }
    this._callingMap.set(newCalling.userId, newCalling)
  }

  clear = () => {
    this._callingMap.clear()
  }
}
